import { render, staticRenderFns } from "./RepInfo.vue?vue&type=template&id=bf7a1520&scoped=true"
import script from "./RepInfo.vue?vue&type=script&lang=js"
export * from "./RepInfo.vue?vue&type=script&lang=js"
import style0 from "./RepInfo.vue?vue&type=style&index=0&id=bf7a1520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7a1520",
  null
  
)

export default component.exports